module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/111.87379552.png";